import "~/observability/setup";

import { render } from "solid-js/web";

import { createInertiaApp } from "~/inertia";

createInertiaApp({
  id: "public-inertia-root",
  resolve(name) {
    const pages = import.meta.glob<{
      default: { layout?: unknown };
    }>(["../pages/{schedule,public}/**/*.tsx", "!../pages/**/*.spec.tsx"], {
      eager: true,
    });
    const page = pages[`../pages/${name}.tsx`]!;
    return page;
  },
  setup({ el, App, props }) {
    render(() => <App {...props} />, el);
  },
});
